import * as React from "react";
import { TrendingUp, BadgeDollarSign, MapPin, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Expert Guidance",
  description: "Our seasoned brokers provide personalized strategies to secure the most competitive rates available.",
  icon: TrendingUp,
  iconColor: "text-secondary",
  link: "/LoanOptionsPage"
}, {
  title: "Transparent Terms",
  description: "We believe in absolute clarity. No hidden fees, just straightforward lending you can trust.",
  icon: BadgeDollarSign,
  iconColor: "text-secondary",
  link: "/LoanOptionsPage"
}, {
  title: "Local Market Mastery",
  description: "Deeply rooted in the community, we understand the local landscape to find your perfect home.",
  icon: MapPin,
  iconColor: "text-secondary",
  link: "/LoanOptionsPage"
}];
export default function ThePremierAdvantage() {
  return <section data-section-id="225002" id="the-premier-advantage" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            The Premier Advantage
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-default">
            Experience a higher standard of mortgage brokering. We combine financial precision with a commitment to your long-term prosperity.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <Link to={feature.link} className="absolute inset-0 z-10">
                <span className="sr-only">Learn more about {feature.title}</span>
              </Link>
              <Card className="flex h-full flex-col justify-between rounded-md border border-border bg-secondary/10 backdrop-blur-md shadow-lg transition-all duration-300 group-hover:-translate-y-2 group-hover:border-secondary">
                <div>
                  <CardHeader className="pb-4">
                    <feature.icon className={`mb-4 size-16 stroke-[1.5] ${feature.iconColor}`} aria-hidden="true" />
                    <CardTitle className="font-default text-2xl font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground font-default">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex items-center text-sm font-bold text-secondary opacity-0 transition-all duration-300 group-hover:translate-x-2 group-hover:opacity-100">
                    Explore Options <ArrowRight className="ml-2 size-4 stroke-[3]" />
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}